import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { MonthChargeTypesValuationModel } from '../../Models/Models/AdviserCharges/MonthChargeTypesValuationModel';
import { IJsonDate } from '../../System/IJsonDate';
import { ServiceProposition } from '../../Constants/Enums/ServiceProposition';

declare var IS_RUNNING_IN_APP_POOL;

export class MonthlyChargeTypesValuationClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(companyHierarchyId: string, adviserHierarchyId: string, fromDate: IJsonDate, toDate: IJsonDate, servicePropositions: Array<ServiceProposition>): Promise<Array<MonthChargeTypesValuationModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/AdviserCharges/MonthlyChargeTypesValuation/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { companyHierarchyId: companyHierarchyId, adviserHierarchyId: adviserHierarchyId, fromDate: fromDate, toDate: toDate, servicePropositions: servicePropositions }

    return AjaxWrapper.get<Array<MonthChargeTypesValuationModel>, any>(url, data);
  }
}

